import { render, staticRenderFns } from "./DocumentsSection.vue?vue&type=template&id=26f15dac&scoped=true&"
import script from "./DocumentsSection.vue?vue&type=script&lang=js&"
export * from "./DocumentsSection.vue?vue&type=script&lang=js&"
import style0 from "./DocumentsSection.vue?vue&type=style&index=0&id=26f15dac&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26f15dac",
  null
  
)

export default component.exports